import Image from "next/image";

import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import DeclarationBoxItemMinutes from "../../components/DeclarationBoxItemMinutes";

import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from "../../components/Accordion";

import Transportowe from "../../content/przyjaznedeklaracje/wazne-terminy/accordion/podatek-od-srodkow-transportowych/section_pl.mdx";
import Nieruchomosci from "../../content/przyjaznedeklaracje/wazne-terminy/accordion/podatek-od-nieruchomosci/section_pl.mdx";
import Rolny from "../../content/przyjaznedeklaracje/wazne-terminy/accordion/podatek-rolny/section_pl.mdx";
import Lesny from "../../content/przyjaznedeklaracje/wazne-terminy/accordion/podatek-lesny/section_pl.mdx";
import Odpadykomunalne from "../../content/przyjaznedeklaracje/wazne-terminy/accordion/oplata-za-gospodarowanie-odpadami-komunalnymi/section_pl.mdx";
import TranslatedMessage from "../../components/TranslatedMessage";
import MDX from "../../components/MDX";

export default function WazneTerminy(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "wazneterminy";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section>
				<div className="accordion-template--primary">
					<Accordion allowMultipleExpanded preExpanded={["0", "1", "2", "3", "4"]}>
						{Variables.miasta[Miasto].wazneTerminy.map((wazneTerminy, index) => (
							<AccordionItem key={index}>
								<AccordionItemHeading aria-level={2}>
									<AccordionItemButton itemIndex={index}>
										<Image
											unoptimized
											src={wazneTerminy.images.normal.url}
											alt=""
											width={wazneTerminy.images.normal.width}
											height={wazneTerminy.images.normal.height}
											style={{
												maxWidth: "100%",
												height: "auto",
											}}
										/>
										<h3 className="accordion__title">
											<TranslatedMessage id={wazneTerminy.title} />
										</h3>
									</AccordionItemButton>
								</AccordionItemHeading>
								<AccordionItemPanel itemIndex={index}>
									<MDX>
										{wazneTerminy.name === "Transportowe" && <Transportowe />}
										{wazneTerminy.name === "Nieruchomosci" && <Nieruchomosci />}
										{wazneTerminy.name === "Rolny" && <Rolny />}
										{wazneTerminy.name === "Lesny" && <Lesny />}
										{wazneTerminy.name === "Odpadykomunalne" && <Odpadykomunalne />}
									</MDX>
								</AccordionItemPanel>
							</AccordionItem>
						))}
					</Accordion>
				</div>
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => (
						<DeclarationBoxItem
							miasto={Miasto}
							podatek={declarationBoxItem.title}
							key={index}
							soon={declarationBoxItem.soon && true}
						/>
					))}
					<DeclarationBoxItemMinutes />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} context={Podatek} />
			</Section>
		</SectionLayout>
	);
}
